module.exports = __webpack_public_path__ + "static/media/Mallorca Way, San Francisco, CA2.e10b055a.jpg";